import { ele } from "cables-shared-client";
import api from "../api.js";
import web from "../index.js";

export default class PageExamples
{
    constructor(targetElement)
    {
        // (targetEl, exampleId, sandboxUrl)
        const exampleId = targetElement.dataset.exampleid;
        const sandboxUrl = targetElement.dataset.sandboxurl;
        if (exampleId)
        {
            api.get("project/" + exampleId, (exampleObj) =>
            {
                web.embedPatch({
                    "projectId": exampleId,
                    "elementId": "examplecontainer",
                    "sandboxUrl": sandboxUrl
                });
            });


            const eleNav = ele.byId(exampleId);
            if (eleNav)
            {
                eleNav.parentElement.parentElement.scrollIntoView({ "block": "start", "inline": "end" });
                eleNav.classList.add("active");
            }
        }
        else
        {
            api.get("examples", (result) =>
            {
                let html = "";
                for (const i in result)
                {
                    html += web.getHandleBarHtml("example", result[i]);
                }
                ele.byId("example-thumbs").innerHTML = html;
            });
        }
    }
}
